import React from 'react';
import { Image as AntdImage } from 'antd';
import ImagePlaceholder from 'assets/img/placeholder/image_placeholder.svg';

const FALLBACK_IMAGE = ImagePlaceholder;

export const Image = (props) => {
  const [hasError, setHasError] = React.useState(false);
  return (
    <AntdImage
      style={hasError ? { objectFit: 'cover' } : {}}
      onError={() => {
        setHasError(true);
      }}
      fallback={FALLBACK_IMAGE}
      preview={false}
      {...props}
    />
  );
};
